var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"kstmod-receive-relatedlist"},[_c('Action',{attrs:{"access":_vm.access,"purchaseId":_vm.purchaseId}}),_c('Row',{attrs:{"access":_vm.access,"detailed":_vm.detailed,"items":_vm.items}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }